import React from 'react';
import { FileTextIcon, EditIcon, SaveIcon, CancelIcon } from '../../components/icons/Icons';

interface DescriptionCardProps {
  description: string;
  isProjectManager: boolean;
  editingDescription: boolean;
  draftDescription: string;
  onStartEditDescription: () => void;
  onSaveDescription: () => void;
  onCancelEditDescription: () => void;
  onDraftDescriptionChange: (value: string) => void;
}

export const DescriptionCard: React.FC<DescriptionCardProps> = ({
  description,
  isProjectManager,
  editingDescription,
  draftDescription,
  onStartEditDescription,
  onSaveDescription,
  onCancelEditDescription,
  onDraftDescriptionChange,
}) => {
  return (
    <div className="detail-card full-width">
      <h3 className="detail-card-title">
        <FileTextIcon />
        Description
        {isProjectManager && (
          <div className="action-btn-group ml-auto">
            {editingDescription ? (
              <>
                <button className="action-icon-btn save" onClick={onSaveDescription} title="Save"><SaveIcon /></button>
                <button className="action-icon-btn cancel" onClick={onCancelEditDescription} title="Cancel"><CancelIcon /></button>
              </>
            ) : (
              <button className="action-icon-btn edit" onClick={onStartEditDescription} title="Edit"><EditIcon /></button>
            )}
          </div>
        )}
      </h3>
      {editingDescription ? (
        <div className="desc-edit-wrap">
          <textarea className="desc-edit-textarea" value={draftDescription} onChange={e => onDraftDescriptionChange(e.target.value)} rows={5} autoFocus />
        </div>
      ) : (
        <p className="task-description-text">{description || 'No description provided.'}</p>
      )}
    </div>
  );
};
